'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dFeatures$0024 from "./presto.types$-Features$.js";
var $p;
/** @constructor */
function $c_Lpresto_ListCredentialsPage(hash) {
  this.CV = null;
  this.CV = hash;
}
export { $c_Lpresto_ListCredentialsPage as $c_Lpresto_ListCredentialsPage };
$p = $c_Lpresto_ListCredentialsPage.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ListCredentialsPage;
/** @constructor */
function $h_Lpresto_ListCredentialsPage() {
}
export { $h_Lpresto_ListCredentialsPage as $h_Lpresto_ListCredentialsPage };
$h_Lpresto_ListCredentialsPage.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_ListCredentialsPage)) {
    var x = this.CV;
    var x$2 = x$0.CV;
    return ((x === null) ? (x$2 === null) : x.i(x$2));
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "ListCredentialsPage";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.CV;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.dw = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_presto$002etypes$0024$002dFeatures$0024.$m_Lpresto_types$Features$().lH);
});
function $isArrayOf_Lpresto_ListCredentialsPage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iE)));
}
export { $isArrayOf_Lpresto_ListCredentialsPage as $isArrayOf_Lpresto_ListCredentialsPage };
var $d_Lpresto_ListCredentialsPage = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ListCredentialsPage, "presto.ListCredentialsPage", ({
  iE: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_ListCredentialsPage as $d_Lpresto_ListCredentialsPage };
//# sourceMappingURL=presto.-List-Credentials-Page.js.map
